var _circle, _path, _circle2, _circle3, _path2, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 16,
    r: 4,
    fill: "#B1E2FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 18.5C3 18.5 3.5 13 9 13C13.0035 13 14.3577 15.9141 14.7983 17.5",
    stroke: "#081E28",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 7.5,
    r: 2.5,
    fill: "#B1E2FA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 3.375,
    stroke: "#081E28",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.5C19.0787 16.5 19.8025 16.884 20.3037 17.3809C20.8172 17.89 21.1198 18.5416 21.2939 19.0908C21.3279 19.1979 21.3039 19.2869 21.2441 19.3584C21.1791 19.4361 21.0628 19.5 20.9131 19.5H15.0869C14.9372 19.5 14.8209 19.4361 14.7559 19.3584C14.6961 19.2869 14.6721 19.1979 14.7061 19.0908C14.8802 18.5416 15.1828 17.89 15.6963 17.3809C16.1975 16.884 16.9213 16.5 18 16.5Z",
    fill: "#081E28",
    stroke: "#081E28"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 14,
    r: 1.5,
    fill: "#081E28",
    stroke: "#081E28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKids);
export default __webpack_public_path__ + "static/media/kids.878313bf514f1fc7ab924be5c39cdc0e.svg";
export { ForwardRef as ReactComponent };